import React from 'react';
import Tabs from 'components/utilities/tabs/Tabs';
import { useSelector } from 'react-redux';

// Import helrpes
import { channelsTabs } from './helpers/index';

const ChannelsTabs = () => {
	const { languages: contentTranslationLanguages } = useSelector(
		({ content_translations }) => content_translations.language_list
	);
	return <Tabs tabs={channelsTabs(contentTranslationLanguages)} />;
};

export default ChannelsTabs;
